// frontend/src/components/SolicitarProgramaModal/SolicitarProgramaModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Typography, message } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { solicitarProgramaFidelidade } from '../../services/milhasService';
import { getErrorMessage } from '../../utils/errorHandler';
import { getMobileFullscreenModalProps } from '../../utils/mobileModal';

const { Text } = Typography;

const SolicitarProgramaModal = ({ visible, onClose, nomeInicial = '' }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            form.setFieldsValue({ nome: nomeInicial });
        }
    }, [visible, nomeInicial, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            await solicitarProgramaFidelidade(values);
            messageApi.success('Pedido enviado! Avisaremos por e-mail quando o programa estiver disponível.');
            onClose();
        } catch (error) {
            if (error?.errorFields) return;
            const erroNome = error?.response?.data?.nome;
            messageApi.error(
                (Array.isArray(erroNome) ? erroNome[0] : erroNome)
                || getErrorMessage(error, 'Erro ao enviar o pedido.')
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {contextHolder}
            <Modal
                title="Solicitar Novo Programa"
                open={visible}
                onCancel={onClose}
                onOk={handleOk}
                confirmLoading={loading}
                okText="Enviar Pedido"
                cancelText="Cancelar"
                okButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
                cancelButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
                {...getMobileFullscreenModalProps(isMobile)}
            >
                <Text type="secondary">
                    Não encontrou o programa no catálogo? Peça para a equipe cadastrar. Você recebe um e-mail quando ele estiver disponível.
                </Text>
                <Form form={form} layout="vertical" size={isMobile ? 'large' : 'middle'} style={{ marginTop: 16 }}>
                    <Form.Item
                        name="nome"
                        label="Nome do Programa"
                        rules={[{ required: true, whitespace: true, message: 'Informe o nome do programa.' }]}
                    >
                        <Input maxLength={100} placeholder="Ex.: Pontos do banco X" />
                    </Form.Item>
                    <Form.Item name="observacao" label="Observação (opcional)">
                        <Input.TextArea rows={3} maxLength={500} placeholder="Site do programa, banco ou cartão ligado a ele etc." />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default SolicitarProgramaModal;
